module.exports = __webpack_public_path__ + "static/media/enproceso.49b7f9cc.png";